/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { WorkPackageStatuses } from '../../constants/storyStatusTypes';
import { updateCadence } from '../../actions/cadenceActions';
import {
  startSprint,
  planSprint,
  validateEndDateOfSprint
} from '../../utils/sprintHelpers';

class CadenceDetailStatus extends React.Component {
  handleClick = (event) => {
    event.preventDefault();
    const newStatus = event.target.name;
    const { cadence } = this.props;

    if (newStatus === WorkPackageStatuses.ACCEPTED) {
      // handle user marking cadence as DONE
      validateEndDateOfSprint(cadence);
    } else if (newStatus === WorkPackageStatuses.IN_PROGRESS) {
      // handle user marking cadence as IN PROGRESS
      startSprint(cadence);
    } else {
      planSprint(cadence);
    }
  };

  render() {
    const { status } = this.props;
    const disabled = !this.props.allowEdit;

    return (
      <div className="row">
        <div className="col-sm-4">
          <button
            type="button"
            name={WorkPackageStatuses.GETTING_READY}
            className={`status-btn ${
              status === WorkPackageStatuses.GETTING_READY
                ? 'getting-ready-active'
                : 'getting-ready-normal'
            }`}
            onClick={this.handleClick}
            disabled={disabled}
          >
            PLANNING
          </button>
        </div>
        <div className="col-sm-4">
          <button
            type="button"
            name={WorkPackageStatuses.IN_PROGRESS}
            className={`status-btn ${
              status === WorkPackageStatuses.IN_PROGRESS
                ? 'progress-active'
                : 'progress-normal'
            }`}
            onClick={this.handleClick}
            disabled={disabled}
          >
            IN PROGRESS
          </button>
        </div>
        <div className="col-sm-4">
          <button
            type="button"
            name={WorkPackageStatuses.ACCEPTED}
            className={`status-btn ${
              status === WorkPackageStatuses.ACCEPTED
                ? 'accepted-active'
                : 'accepted-normal'
            }`}
            onClick={this.handleClick}
            disabled={disabled}
          >
            DONE
          </button>
        </div>
      </div>
    );
  }
}

CadenceDetailStatus.propTypes = {
  statuses: PropTypes.string,
  targetId: PropTypes.number,
  allowEdit: PropTypes.bool
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateStatus: updateCadence
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(CadenceDetailStatus);
